import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";
type CategoryDTO = {
    id:string;
    name:string;
    description:string;
    img_url:string;
    createdAt:string;
    updatedAt:string
};

type getCategoriesResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: CategoryDTO[];
};
export const GetAllCategories = async (
): Promise<getCategoriesResponse> => {
  try {
    const response = await axios.get(`/category/all`);
    return { data: response.data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
